import { render, staticRenderFns } from "./switchAndIcon.vue?vue&type=template&id=6d4e6d2b&scoped=true"
import script from "./switchAndIcon.vue?vue&type=script&lang=js"
export * from "./switchAndIcon.vue?vue&type=script&lang=js"
import style0 from "./switchAndIcon.vue?vue&type=style&index=0&id=6d4e6d2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e6d2b",
  null
  
)

export default component.exports